import script from "./DishImage.vue?vue&type=script&setup=true&lang=js"
export * from "./DishImage.vue?vue&type=script&setup=true&lang=js"

import "./DishImage.vue?vue&type=style&index=0&id=904ceee8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-904ceee8"]])

export default __exports__